import { render, staticRenderFns } from "./BaiduShare.vue?vue&type=template&id=3bfbdb38&scoped=true"
import script from "./BaiduShare.vue?vue&type=script&lang=js"
export * from "./BaiduShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbdb38",
  null
  
)

export default component.exports